import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { SubCategory, SubCategoriesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class SubCategoriesDataService {

  private uri: string = `${environment.apiUrl}sub-categories`;
  private cacheKey: string = 'subCategories.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getSubCategory(id: number): Observable<SubCategory|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSubCategories(parameters: {[param: string]: string | string[]}): Observable<SubCategoriesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addSubCategory(data: SubCategory): Observable<SubCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addSubCategories(data: SubCategory[]): Observable<SubCategory[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateSubCategory(data: SubCategory): Observable<SubCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSubCategories(data: SubCategory[]): Observable<SubCategory[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchSubCategory(data: SubCategory): Observable<SubCategory|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSubCategories(data: SubCategory[]): Observable<SubCategory[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteSubCategory(data: SubCategory): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSubCategories(data: SubCategory[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((subCategory) => {
      ids.push(subCategory.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
